import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { NavigationService } from '../../../service/navigation.service';

// Interface
import { MenuBottom } from '../../../../../utils/models/layout.interface';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from "../../inputs/button/button.component";
import { AuthService } from 'src/app/service/auth/auth.service';
import { Router } from '@angular/router';

const TIME_SLEEP = 300;
@Component({
  selector: 'app-sidenav-bottom',
  templateUrl: './sidenav-bottom.component.html',
  styleUrls: ['./sidenav-bottom.component.scss'],
  imports: [
    CommonModule,
    SharedModule
  ],
  standalone: true
})
export class SidenavBottomComponent implements OnInit {

  @Input() menuBottom: MenuBottom;
  @Input() collapseControl: any;
  @Input() drawer: any;
  @Output() collapse = new EventEmitter();
  @Output() collapsedUserPanel = new EventEmitter();

  collapseValue;

  hideButton = true
  isHandset$: Observable<boolean>

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly nav: NavigationService,
    private readonly auth: AuthService,
    private readonly route: Router
  ) {
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches))
  }

  ngOnInit() {
    this.collapseValue = false
    if (this.collapseControl !== false) {
      this.collapseValue = true;
    }
    this.isHandset$.subscribe((res) => {
      if (res) {
        this.hideButton = false
      } else {
        this.hideButton = true
      }
    })

    this.nav.colapseMenu.subscribe(res => {
      this.sendCollapse();
    })
  }

  sendCollapse() {
    this.drawer.toggle();
    this.sendCollapsedUserPanel();
    this.sleep(TIME_SLEEP).then(() => {
      this.collapseValue = !this.collapseValue;
      this.collapse.emit(this.collapseValue);
    });

    this.sleep(TIME_SLEEP).then(() => {
      this.drawer.toggle();
    });
  }

  sendCollapsedUserPanel() {
    this.collapsedUserPanel.emit(false);
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  handleExit() {
    this.auth.removeLocalStorage().then(() => {
      this.route.navigate(['/autenticacao/login']);
    })
  }

}
